import loadable from '@loadable/component';

const SectionLoadable = loadable(() => import(/* webpackChunkName: "section-component" */ './index'));

export default SectionLoadable;
